<template>
  <section class="section container pt-0">
    <department-datatable />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import DepartmentDatatable from "./department_datatable/Index.vue";
export default {
  name: "StaffDepartments",
  components: {
    DepartmentDatatable,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
